/*
 * @Author: victorjhu
 * @Date: 2023-01-03 17:27:53
 */
import { isServer } from './is-server';
/**
 * 从document获取cookie
 * @param cookieName {string} cookie名称
 * @param cookieSource {string} next.js从ctx.req.headers.cookie获取cookie, 如果为空则从document获取
 */
export function getCookie(cookieName, cookieSource) {
    var arr;
    var cookieValue = '';
    var reg = new RegExp("(^| )".concat(cookieName, "=([^;]*)(;|$)"));
    if (cookieSource && typeof cookieSource === 'string') {
        cookieValue = cookieSource;
    }
    else if (!isServer) {
        cookieValue = document.cookie;
    }
    if ((arr = cookieValue.match(reg))) {
        return unescape(arr[2]);
    }
    return null;
}
